import { render, staticRenderFns } from "./MainGroups.vue?vue&type=template&id=2fa22ab0"
import script from "./MainGroups.vue?vue&type=script&lang=js"
export * from "./MainGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports